import { API_URL } from "./api";

export async function startCheckout() {
  const res = await fetch(`${API_URL}/billing/checkout`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) throw new Error("Impossible de démarrer la souscription");
  const data = await res.json();
  if (data.url) {
    window.location.href = data.url;
  }
}

export async function startCheckoutAddon() {
  const res = await fetch(`${API_URL}/billing/checkout-addon`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) throw new Error("Impossible de démarrer l'addon espace");
  const data = await res.json();
  if (data.url) {
    window.location.href = data.url;
  }
}
